import React from 'react';

/**
 * Create divider which visually seperates DropdownItems.
 *
 * @function DropdownDivider
 * @returns {React.ReactComponent} DropdownDivider
 * @displayName DropdownDivider (Web)
 * @public
 */
export default function DropdownDivider() {
  return <hr role='presentation' className='dropdown-divider' />;
}
